module.exports = __webpack_public_path__ + "static/img/bonus_8.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_8.png
// module id = vMDu
// module chunks = 0